import { styled } from 'styled-components';

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: ${({ theme }) => theme.main};
`;

export const PageSubtitle = styled.p`
  margin: 2px 0 16px;
  font-size: 13px;
  color: ${({ theme }) => theme.lightText};
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 12px;
`;

export const StatusTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const StatusTab = styled.button<{ $active?: boolean }>`
  border: none;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: ${({ theme, $active }) => ($active ? theme.main : theme.defaultLink)};
  background: ${({ theme, $active }) =>
    $active ? theme.primaryBg10 : 'transparent'};

  &:hover {
    background: ${({ theme }) => theme.primaryBg10};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primaryBg};
    outline-offset: 1px;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;

  .ant-input-affix-wrapper,
  .ant-input,
  .ant-picker,
  .ant-picker-input > input,
  .ant-select,
  .ant-select-selector,
  .transport-export {
    font-size: 14px;
    border-radius: 6px;
  }

  .transport-search {
    flex: 1 1 260px;
    min-width: 220px;
    background: ${({ theme }) => theme.defaultGrayBgColor};

    .ant-input {
      background: transparent;
    }

    .ant-input-prefix {
      margin-inline-end: 8px;
      color: ${({ theme }) => theme.lightText};
    }
  }

  .transport-filter {
    flex: 0 0 auto;
    width: 170px;
    color: ${({ theme }) => theme.textColor};

    .ant-select-prefix,
    .ant-picker-prefix,
    .ant-select-selection-placeholder,
    .ant-select-arrow,
    .ant-picker-suffix {
      color: ${({ theme }) => theme.textColor};
    }
  }

  .transport-export {
    flex: 0 0 auto;
    font-weight: 600;
  }
`;

export const AppliedFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;

  .ant-tag {
    margin: 0;
    font-size: 13px;
    padding: 2px 8px;
    border-radius: 999px;
  }
`;

export const AppliedFiltersLabel = styled.span`
  margin-right: 4px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.lightText};
`;

export const ResultBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const ResultCount = styled.span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.lightText};
`;

export const SortLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.lightText};
`;

export const LoadTableContainer = styled.div`
  .ant-table-tbody > tr {
    cursor: pointer;
  }

  .ant-table-tbody > tr:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primaryBg};
    outline-offset: -2px;
  }

  .ant-table-tbody > tr:focus-visible > td.ant-table-cell-ellipsis {
    white-space: normal;
    overflow: visible;
    overflow-wrap: anywhere;
  }

  .ant-table-tbody > tr.transport-selected-row > td,
  .ant-table-tbody > tr.transport-selected-row:hover > td {
    background: ${({ theme }) => theme.primaryBg10};
  }

  .ant-table-tbody > tr.transport-selected-row > td:first-child {
    box-shadow: inset 3px 0 0 ${({ theme }) => theme.primaryBg};
  }
`;

export const DrawerViewport = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const DrawerSticky = styled.div`
  position: sticky;
  top: 0;
  height: min(100%, 100cqh);
  pointer-events: none;
`;

export const VinMatch = styled.div`
  margin-top: 2px;
  font-size: 11px;
  line-height: 15px;
  color: ${({ theme }) => theme.lightText};
  overflow-wrap: anywhere;
`;

export const VinMatchLabel = styled.div``;

export const SearchNotice = styled.div`
  margin-top: -8px;
  font-size: 12px;
  color: ${({ theme }) => theme.lightText};
`;

export const Emphasis = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.main};
`;

export const RowChevron = styled.span`
  color: ${({ theme }) => theme.lightText};
`;
